/* Ounce — the cookie bar (snippets/consent.liquid). Shopify's Customer Privacy API decides whether the visitor's region
   needs consent and keeps the choice; this file only shows the bar and passes the choice on.
   https://shopify.dev/docs/api/customer-privacy
   Accept: counting visits (analytics) and remembering choices (preferences). Marketing stays off: the shop has no
   advertising cookies, and the privacy page says so. Decline: all of them off, and no sale of data.
   ?consent=show treats the region as one that needs consent (for testing); it changes nothing else. */
(() => {
  'use strict';
  const bar = document.querySelector('[data-consent]'), say = document.querySelector('[data-consent-say]');
  if (!bar) return;
  const FORCE = new URLSearchParams(location.search).get('consent') === 'show';
  const CHOICE = {
    yes: { analytics: true, preferences: true, marketing: false },
    no: { analytics: false, preferences: false, marketing: false, sale_of_data: false },
  };
  const root = document.documentElement;
  let api = null, loading = null;

  /* Shopify.loadFeatures comes with content_for_header; the API itself is fetched from Shopify on first use */
  const load = () => loading ||= new Promise(resolve => {
    if (window.Shopify?.customerPrivacy) return resolve(window.Shopify.customerPrivacy);
    if (!window.Shopify?.loadFeatures) return resolve(null);
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], err => resolve(err ? null : window.Shopify.customerPrivacy || null));
  }).then(p => (api = p));

  const decided = () => { const c = api?.currentVisitorConsent?.() || {}; return c.analytics === 'yes' || c.analytics === 'no'; };

  function show() {
    if (!bar.hidden) return;
    bar.hidden = false;
    root.style.setProperty('--consent-h', bar.offsetHeight + 'px');   // the toast sits above the bar while it is open
    root.classList.add('consent-on');
    requestAnimationFrame(() => requestAnimationFrame(() => bar.classList.add('on')));
    if (say) say.textContent = 'Cookies: ' + bar.querySelector('.consent-text').textContent.trim().replace(/\s+/g, ' ');
  }
  function hide() {
    if (bar.contains(document.activeElement)) document.activeElement.blur();
    bar.classList.remove('on'); bar.hidden = true;
    root.classList.remove('consent-on'); root.style.removeProperty('--consent-h');
  }

  bar.addEventListener('click', e => {
    const b = e.target.closest('[data-consent-choice]'); if (!b) return;
    const yes = b.dataset.consentChoice === 'yes';
    hide();
    if (say) say.textContent = yes ? 'Cookies accepted.' : 'Cookies declined.';
    load().then(p => p?.setTrackingConsent(CHOICE[yes ? 'yes' : 'no'], () => { }));
  });

  /* the footer's "Cookie settings" link: open the bar again, wherever the visitor is. Without the API it stays a link
     to the privacy section. */
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-consent-open]'); if (!a) return;
    e.preventDefault();
    load().then(p => {
      if (!p) { location.href = a.href; return; }
      show();
      bar.querySelector('[data-consent-choice]').focus();   // asked for, so focus goes to it
    });
  });
  addEventListener('resize', () => { if (!bar.hidden) root.style.setProperty('--consent-h', bar.offsetHeight + 'px'); }, { passive: true });

  /* a choice made elsewhere (another tab, Shopify's own banner) closes the bar */
  document.addEventListener('visitorConsentCollected', () => { if (!bar.hidden) hide(); });

  /* after the page has loaded and gone quiet, so the bar never competes with the page for the first paint */
  const idle = window.requestIdleCallback || (f => setTimeout(f, 200));
  const start = () => idle(() => setTimeout(() => load().then(p => {
    if (p && (FORCE || p.shouldShowBanner()) && !decided()) show();
  }), 400), { timeout: 2000 });
  if (document.readyState === 'complete') start(); else addEventListener('load', start, { once: true });
})();
